import React from 'react';
import LoaderComponent from 'react-loader-spinner'

const Loader = ({ loader, setLoader }) => {
  return (
    <>
      <LoaderComponent className="loading"
        type="Oval"
        color="#33ACE1"
        visible={loader}
        height={100}
        width={100}
      />
    </>
  );
}

export default Loader;